var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRocketColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3822 17.3272L21.2292 11.4972C22.0712 10.6582 22.4922 10.2382 22.7132 9.7052C22.9352 9.1702 22.9352 8.5772 22.9352 7.3902V6.8232C22.9352 4.9972 22.9352 4.0842 22.3662 3.5172C21.7972 2.9502 20.8822 2.9502 19.0512 2.9502H18.4812C17.2912 2.9502 16.6962 2.9502 16.1612 3.1712C15.6252 3.3922 15.2042 3.8122 14.3612 4.6512L8.51524 10.4812C7.53124 11.4612 6.92124 12.0702 6.68524 12.6572C6.61165 12.8354 6.57361 13.0264 6.57324 13.2192C6.57324 14.0212 7.22024 14.6672 8.51524 15.9582L8.68924 16.1312L10.7272 14.0622C10.7964 13.992 10.8787 13.9361 10.9694 13.8977C11.0602 13.8593 11.1576 13.8392 11.2561 13.8385C11.3546 13.8377 11.4523 13.8564 11.5436 13.8934C11.6349 13.9304 11.7181 13.9851 11.7882 14.0542C11.8584 14.1233 11.9143 14.2056 11.9527 14.2964C11.9911 14.3871 12.0112 14.4845 12.012 14.583C12.0127 14.6816 11.9941 14.7793 11.957 14.8706C11.92 14.9619 11.8654 15.045 11.7962 15.1152L9.75124 17.1902L9.88824 17.3272C11.1832 18.6172 11.8312 19.2632 12.6352 19.2632C12.8132 19.2632 12.9832 19.2322 13.1542 19.1692C13.7572 18.9472 14.3732 18.3332 15.3822 17.3272ZM18.1292 10.4812C17.7645 10.8446 17.2706 11.0486 16.7557 11.0486C16.2409 11.0486 15.747 10.8446 15.3822 10.4812C15.202 10.3017 15.0589 10.0883 14.9613 9.85342C14.8637 9.61849 14.8135 9.36659 14.8135 9.1122C14.8135 8.8578 14.8637 8.6059 14.9613 8.37097C15.0589 8.13604 15.202 7.9227 15.3822 7.7432C15.747 7.3798 16.2409 7.17575 16.7557 7.17575C17.2706 7.17575 17.7645 7.3798 18.1292 7.7432C18.3095 7.9227 18.4525 8.13604 18.5501 8.37097C18.6477 8.6059 18.698 8.8578 18.698 9.1122C18.698 9.36659 18.6477 9.61849 18.5501 9.85342C18.4525 10.0883 18.3095 10.3017 18.1292 10.4812Z",
    fill: "url(#paint0_linear_3443_13239)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.9664 6.91366L7.4234 9.45066C6.9564 9.91666 6.5274 10.3437 6.1884 10.7307C5.9593 10.986 5.75223 11.2603 5.5694 11.5507L5.5454 11.5257L5.4504 11.4317C5.00803 11.0029 4.48812 10.6621 3.9184 10.4277L3.7954 10.3777L3.4164 10.2277C3.29837 10.1811 3.19379 10.1059 3.11209 10.0089C3.0304 9.91179 2.97416 9.79591 2.94846 9.67167C2.92276 9.54743 2.9284 9.41874 2.96488 9.29723C3.00136 9.17572 3.06752 9.0652 3.1574 8.97566C4.2774 7.85766 5.6224 6.51666 6.2724 6.24766C6.83668 6.01087 7.45466 5.93172 8.0604 6.01866C8.6064 6.09966 9.1224 6.38066 9.9664 6.91366ZM14.3094 20.2637C14.5144 20.4717 14.6494 20.6187 14.7734 20.7757C14.9354 20.9827 15.0804 21.2027 15.2074 21.4337C15.3494 21.6937 15.4604 21.9707 15.6814 22.5257C15.725 22.6304 15.7937 22.7229 15.8814 22.7948C15.9692 22.8667 16.0733 22.916 16.1846 22.9381C16.2959 22.9602 16.411 22.9546 16.5196 22.9218C16.6282 22.8889 16.7271 22.8298 16.8074 22.7497L16.8914 22.6667C18.0114 21.5497 19.3564 20.2087 19.6264 19.5617C19.8636 18.9996 19.9428 18.3834 19.8554 17.7797C19.7744 17.2347 19.4934 16.7197 18.9584 15.8777L16.4064 18.4217C15.9284 18.8987 15.4904 19.3357 15.0934 19.6777C14.8564 19.8837 14.5964 20.0877 14.3094 20.2637Z",
    fill: "url(#paint1_linear_3443_13239)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3443_13239",
    x1: 22.9352,
    y1: 2.95019,
    x2: 5.7623,
    y2: 3.90147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234764,
    stopColor: "#FF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538685,
    stopColor: "#FF7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799781,
    stopColor: "#FF6A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3443_13239",
    x1: 19.8899,
    y1: 5.98437,
    x2: 2.09178,
    y2: 6.96677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234764,
    stopColor: "#FF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538685,
    stopColor: "#FF7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799781,
    stopColor: "#FF6A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRocketColor);
export default __webpack_public_path__ + "static/media/icon-rocketColor.ebc0fc8c1c58387c0a9b71460be182bd.svg";
export { ForwardRef as ReactComponent };